export default __webpack_public_path__ + "5fe4be9a5554a1999cc70da6c08a96a9.png";